module.exports = __webpack_public_path__ + "media/images/icons/comunidad-musical-acd4339680563866720e9391c2b4b48d.svg";